function requestAPI(token, code) {
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:3000/v1/'
  const url = baseUrl.endsWith('/v1/')
    ? `${baseUrl}transaction/detail/${code}`
    : `${baseUrl}/v1/transaction/detail/${code}`

  const headers = {
    'Content-Type': 'application/json'
  }

  if (token) {
    headers['Authorization'] = 'Bearer ' + token
  }

  return fetch(url, {
    method: 'GET',
    headers: headers
  }).then((res) => res.json())
}

export default function actionDetailTransactionPublic(codeParam) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'DETAIL_TRANSACTION_BEGIN'
      })

      const token = (getState().auth && getState().auth.authenticate && getState().auth.authenticate.token)
        ? getState().auth.authenticate.token
        : localStorage.getItem('nabawi-token')

      const result = await requestAPI(token, codeParam)

      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'DETAIL_TRANSACTION_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'DETAIL_TRANSACTION_FAILURE',
    error: error
  })
}
